import type { ChangeViews } from 'entities/history';

import { SeveralRowsValue } from './SeveralRowsValue';
import { OldToNewValue } from './OldToNewValue';
import { CardEvent } from './CardEvent';
import { AssignedEvent } from './AssignedEvent';
import { IntegrationEvent } from './IntegrationEvent';
import { SchedulingUpdateCell } from './SchedulingUpdateCell';
import { ListRows } from './ListRows';
import { OldToNewReason } from './OldToNewReason';
import { OldToNewSeveralRows } from './OldToNewSeveralRows';
import { InvoiceMultipleRowOldNewValues } from './InvoiceMultipleRowOldNewValues';

export function getChangeDetail(changeView: ChangeViews) {
  switch (changeView.viewType) {
    case 'SeveralRowsValue': {
      return <SeveralRowsValue data={changeView.data} />;
    }
    case 'SeveralRowsValueOverflow': {
      return (
        <SeveralRowsValue
          data={changeView.data}
          wrapperClass="!block"
        />
      );
    }
    case 'OldToNewValueText': {
      return (
        <OldToNewValue
          type="text"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueTextCapitalized': {
      return (
        <OldToNewValue
          type="textCapitalized"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValuePausingReasons': {
      return (
        <OldToNewValue
          type="pausingReasons"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueNumber': {
      return (
        <OldToNewValue
          type="number"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueMoney': {
      return (
        <OldToNewValue
          type="money"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueMoneyDate': {
      return (
        <OldToNewValue
          type="money"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
          effectiveAt={changeView.effectiveAt}
        />
      );
    }
    case 'OldToNewValueIsActive': {
      return (
        <OldToNewValue
          type="isActive"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueIsApplied': {
      return (
        <OldToNewValue
          type="isApplied"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueTrafficDays': {
      return (
        <OldToNewValue
          type="trafficDays"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueBidOrBidTiers': {
      return (
        <OldToNewValue
          type="bidOrBidTiers"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueBadge': {
      return (
        <OldToNewValue
          type="badge"
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
        />
      );
    }
    case 'OldToNewValueOnOff': {
      return (
        <OldToNewReason
          oldValue={changeView.oldValue}
          newValue={changeView.newValue}
          reason={changeView.reason}
          reasonDescription={changeView.reasonDescription}
        />
      );
    }
    case 'OldToNewSeveralRows': {
      return <OldToNewSeveralRows data={changeView.data} />;
    }
    case 'CardEventCreated': {
      return (
        <CardEvent
          type="created"
          isDefault={changeView.isDefault}
          last4={changeView.last4}
        />
      );
    }
    case 'CardEventDeleted': {
      return (
        <CardEvent
          type="deleted"
          isDefault={changeView.isDefault}
          last4={changeView.last4}
        />
      );
    }
    case 'CardEventUpdated': {
      return (
        <CardEvent
          type="updated"
          isDefault={changeView.isDefault}
          last4={changeView.last4}
        />
      );
    }
    case 'AssignedEvent': {
      return <AssignedEvent data={changeView.data} />;
    }
    case 'ListRows': {
      return <ListRows data={changeView.data} />;
    }
    case 'SchedulingUpdateCell': {
      return <SchedulingUpdateCell data={changeView.data} />;
    }
    case 'IntegrationEventCreated': {
      return (
        <IntegrationEvent
          type="created"
          isActive={changeView.isActive}
        />
      );
    }
    case 'IntegrationEventUpdated': {
      return (
        <IntegrationEvent
          type="updated"
          isActive={changeView.isActive}
        />
      );
    }
    case 'IntegrationEventDeleted': {
      return (
        <IntegrationEvent
          type="deleted"
          label={changeView.label}
        />
      );
    }
    case 'InvoiceMultipleRowOldNewValues': {
      return <InvoiceMultipleRowOldNewValues data={changeView.data} />;
    }
    case 'EmptyView': {
      return <></>;
    }
    default:
      throw new Error('Unknown campaign event type');
  }
}
